export const FREE_PLAN_ID = 'free';
export const BASIC_PLAN_ID = 'basic'; // kept for DB compat – maps to free
export const PREMIUM_PLAN_ID = 'premium';

export const FEATURE_LABELS = {
  'business-status': 'סטטוס העסק',
  appointments: 'ניהול תורים',
  'my-site': 'האתר שלי',
  approvals: 'מחכים לאישור',
  schedule: 'שעות פעילות',
  'temp-closure': 'פתיחה/סגירה זמנית',
  customers: 'הלקוחות שלי',
  services: 'שירותים',
  'public-discovery': 'חשיפה במפה ובקטלוג',
  waitlist: 'רשימת המתנה',
  analytics: 'ניתוח עסק',
  staff: 'ניהול צוות',
  'advanced-site-design': 'עיצובים מתקדמים לאתר',
  'external-order-link': 'קישור הזמנה חיצוני',
  'no-appointments-mode': 'מצב ללא תורים',
};

/* Free now includes everything that was in Basic */
export const FREE_PLAN_FEATURES = [
  'business-status',
  'external-order-link',
  'no-appointments-mode',
  'appointments',
  'my-site',
  'approvals',
  'schedule',
  'temp-closure',
  'customers',
  'services',
  'public-discovery',
];

/* Kept for backwards-compat – identical to FREE */
export const BASIC_PLAN_FEATURES = FREE_PLAN_FEATURES;

export const PREMIUM_PLAN_FEATURES = [
  'waitlist',
  'analytics',
  'staff',
  'advanced-site-design',
];

const PREMIUM_ONLY_FEATURES = new Set(PREMIUM_PLAN_FEATURES);

export function normalizePlanId(rawValue) {
  const value = String(rawValue || '').trim().toLowerCase();
  if (value === 'free' || value === 'normal' || value === 'basic') {
    return FREE_PLAN_ID;
  }
  if (value === 'premium' || value === 'pro') {
    return PREMIUM_PLAN_ID;
  }
  return FREE_PLAN_ID;
}

export function getBusinessPlan(user) {
  const planId = normalizePlanId(user?.plan?.id || user?.plan_id || user?.planId);
  return {
    id: planId,
    label: planId === PREMIUM_PLAN_ID ? 'Premium' : 'Free',
    isFree: planId !== PREMIUM_PLAN_ID,
    isPremium: planId === PREMIUM_PLAN_ID,
  };
}

export function hasPlanFeature(user, featureKey) {
  if (!featureKey) return true;
  const plan = getBusinessPlan(user);
  if (plan.isPremium) return true;
  /* Free plan now includes all non-premium features */
  return !PREMIUM_ONLY_FEATURES.has(featureKey);
}

export function getFeatureLabel(featureKey) {
  return FEATURE_LABELS[featureKey] || 'הפיצ׳ר הזה';
}

export function getRequiredPlanForFeature(featureKey) {
  if (!featureKey) return FREE_PLAN_ID;
  if (PREMIUM_ONLY_FEATURES.has(featureKey)) return PREMIUM_PLAN_ID;
  return FREE_PLAN_ID;
}

export function getRequiredPlanLabelForFeature(featureKey) {
  const requiredPlan = getRequiredPlanForFeature(featureKey);
  if (requiredPlan === PREMIUM_PLAN_ID) return 'Premium';
  return 'Free';
}